import { getAuthTokenAsync } from "src/store/common";
import { StarFeed, Meta } from "src/store/types";
import * as api from "./api";
import { MediaType } from "src/common/constants";

interface ApiResponse {
  data: StarFeed[];
  meta: Meta;
}

interface SingleStarFeedResponse {
  data: StarFeed;
}

export interface StarFeedPayload {
  title: string;
  description: string;
  media: {
    url: string;
    thumbnail: string;
    type: MediaType;
    size: string;
  }[];
}

export type StarFeedOrderPayloadItem = {
  sfId: string;
  order: number;
};

// fetch star feed list
export const fetchStarFeedList = async (data: {
  page: number;
  limit: number;
  search?: string;
}): Promise<ApiResponse> => {
  const params: Record<string, string | number> = {
    page: data.page,
    limit: data.limit,
  };

  if (data.search?.trim()) {
    params.search = data.search.trim();
  }

  const token = getAuthTokenAsync();
  api.setHeaderAuthorization(token);
  const response: any = await api.get(
    `${process.env.REACT_APP_ADMIN_API_URL}/star-feed`,
    params,
  );
  return response;
};

// create star feed
export const createStarFeed = async (
  data: StarFeedPayload,
): Promise<SingleStarFeedResponse> => {
  const token = getAuthTokenAsync();
  api.setHeaderAuthorization(token);
  const response: any = await api.post(
    `${process.env.REACT_APP_ADMIN_API_URL}/star-feed`,
    data,
  );
  return response;
};

// update star feed
export const updateStarFeed = async (
  sfId: string,
  data: StarFeedPayload,
): Promise<SingleStarFeedResponse> => {
  const token = getAuthTokenAsync();
  api.setHeaderAuthorization(token);
  const response: any = await api.put(
    `${process.env.REACT_APP_ADMIN_API_URL}/star-feed/${sfId}`,
    data,
  );
  return response;
};

// delete star feed
export const deleteStarFeed = (sfId: string) => {
  const token = getAuthTokenAsync();
  api.setHeaderAuthorization(token);
  return api.remove(`${process.env.REACT_APP_ADMIN_API_URL}/star-feed/${sfId}`);
};

// reorder star feed (partial payload — only changed items)
export const reorderStarFeed = async (items: StarFeedOrderPayloadItem[]) => {
  const token = getAuthTokenAsync();
  api.setHeaderAuthorization(token);
  const response: any = await api.put(
    `${process.env.REACT_APP_ADMIN_API_URL}/star-feed/order`,
    items,
  );
  return response;
};
